import { Form, type FormItemProps } from "antd";
import classNames from "~utils/classNames";
import { GlobalStyles, customFormItemClass } from "./FormItem.styles";

export const FormItem = <TForm = unknown>(props: FormItemProps<TForm>) => (
  <>
    <GlobalStyles />
    <Form.Item<TForm> {...props} className={classNames(props.className, customFormItemClass)} />
  </>
);
